export default __webpack_public_path__ + "static/media/HT-0.97206efd.svg";